

export enum Language {
    CS = 'cs',
    SK = 'sk',
    EN = 'en'
  }